<template>
	<div class="TypeList">
		<common-body aside="1">
			<div slot="commonMain" class="list_box">
				<el-row type="flex" align="middle" justify="space-between" class="list_header">
					<div class="list_header_tip">
						<span v-if="selectedCategory">已选分类：{{selectedCategory.name}}</span>
						<span v-else>请选择产品分类后设置报价</span>
					</div>
					<div
						v-if="ruleList.order_add"
						@click="goQuotation"
						class="list_quotation_btn"
						:class="{'list_quotation_btn_disabled': !selectedCategory || saving}"
					>设置报价</div>
				</el-row>
				<div class="list_main">
					<div
						v-for="(item,index) in types"
						:key="item.id"
						class="list_item"
						:class="{'list_item_active': selectedCategory && selectedCategory.id === item.id}"
					>
						<div @click.stop="toggleSelect(item)" class="list_select">
							<i :class="selectedCategory && selectedCategory.id === item.id ? 'el-icon-success' : 'el-icon-circle-check'"></i>
						</div>
						<div @dblclick="goList(item.id)" class="list_item_body">
							<div class="list_img">
								<img :src="[item.image==''?'./src/assets/img/banner.jpg':item.image]" />
							</div>
							<div class="list_content">
								<div class="list_name text_more">{{item.name}}</div>
								<div class="list_dis">{{item.content}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</common-body>
	</div>
</template>

<script>
	const QUOTATION_CATEGORY_KEY = 'quotation_category'

	export default {
		name: 'TypeList',
		data() {
			return {
				types: [],
				typeIndex: 0,
				selectedCategory: null,
				saving: !1,
				ruleList: JSON.parse(localStorage.getItem('ruleList'))
			}
		},
		created() {
			this.reload();
		},
		beforeRouteLeave(to,from,next) {
			if(to.name === 'GoodList'){
				// to.meta.keepAlive = !0
			}
			next()
		},
		methods: {
			reload() {
				let that = this
				that.getType()
			},
			syncLocalCategory(categoryId) {
				if (categoryId) {
					sessionStorage.setItem(QUOTATION_CATEGORY_KEY, String(categoryId))
				} else {
					sessionStorage.removeItem(QUOTATION_CATEGORY_KEY)
				}
				try {
					const raw = localStorage.getItem('userInfo')
					if (!raw) return
					const userInfo = JSON.parse(raw)
					userInfo.quotation_category_id = categoryId ? Number(categoryId) : 0
					localStorage.setItem('userInfo', JSON.stringify(userInfo))
				} catch (e) {}
			},
			getType(e) {
				let that = this
				that.$fetch('addons/hlm/api.Goods/getCategory',{pid: 0}).then(function(res) {
					console.log(res)
					if (res.code == 1) {
						that.types = res.data
						that.loadSelectedCategory()
					}
				}).catch(function(error) {
					console.log(error)
				})
			},
			loadSelectedCategory() {
				let that = this
				that.$fetch('addons/hlm/api.User/getQuotationCategory').then(function(res) {
					if (res.code != 1) {
						that.restoreSelectedCategoryFromSession()
						return
					}
					const categoryId = res.data && res.data.category_id ? Number(res.data.category_id) : 0
					if (categoryId > 0) {
						that.selectedCategory = that.types.find(function(item) {
							return Number(item.id) === categoryId
						}) || null
						that.syncLocalCategory(categoryId)
					} else {
						that.selectedCategory = null
						that.syncLocalCategory(0)
					}
				}).catch(function() {
					that.restoreSelectedCategoryFromSession()
				})
			},
			restoreSelectedCategoryFromSession() {
				let that = this,
					categoryId = sessionStorage.getItem(QUOTATION_CATEGORY_KEY)
				if (!categoryId) return
				that.selectedCategory = that.types.find(function(item) {
					return String(item.id) === String(categoryId)
				}) || null
			},
			persistCategory(categoryId, successMsg) {
				let that = this
				if (that.saving) return Promise.resolve(!1)
				that.saving = !0
				return that.$post('addons/hlm/api.User/setQuotationCategory', {
					category_id: categoryId || 0
				}).then(function(res) {
					if (res.code == 1) {
						that.syncLocalCategory(categoryId || 0)
						if (successMsg) {
							that.$message({
								message: successMsg,
								type: 'success',
								duration: 1500,
								center: !0
							})
						}
						return !0
					}
					return !1
				}).catch(function(error) {
					console.log(error)
					return !1
				}).finally(function() {
					that.saving = !1
				})
			},
			toggleSelect(item) {
				let that = this
				if (that.saving) return
				if (that.selectedCategory && that.selectedCategory.id === item.id) {
					that.selectedCategory = null
					that.persistCategory(0)
					return
				}
				that.selectedCategory = item
				that.persistCategory(item.id)
			},
			goQuotation() {
				let that = this
				if (!that.selectedCategory) {
					that.$message({
						message: '请先选择产品分类',
						center: !0,
						type: 'warning',
						duration: 1500
					})
					return
				}
				if (that.saving) return
				const name = that.selectedCategory.name
				that.$confirm(`确认将当前报价分类设置为「${name}」吗？`, '设置报价', {
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false,
				}).then(function() {
					that.persistCategory(
						that.selectedCategory.id,
						`当前报价已经设置为 ${name}`
					)
				}).catch(function() {})
			},
			goList(e) {
				let that = this
				that.$router.push(`/goodList?id=${e}`)
			}
		}
	};
</script>

<style src='../assets/css/typeList.css'>
	/* px2rem能正常转换 */
</style>
